import React from 'react';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import PromoBanner from '../components/PromoBanner';
import SEO from '../components/SEO';
import { seoData } from '../data/seoData';

const TermsAndConditionsPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <SEO {...seoData.terms} />
      <PromoBanner />
      <Navigation />
      
      {/* Header */}
      <section className="pt-20 pb-16 bg-white">
        <div className="container">
          <div className="text-center max-w-3xl mx-auto">
            <h1 className="display-hero text-gray-900 mb-6">
              Terms & Conditions
            </h1>
            <p className="body-large text-gray-600">
              Please read these terms and conditions carefully before using our service.
            </p>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="py-20">
        <div className="container">
          <div className="max-w-4xl mx-auto">
            <div className="bg-white rounded-xl shadow-sm p-8 md:p-12 border border-gray-100">
              <div className="prose prose-lg max-w-none">
                <h2>Acceptance of Terms</h2>
                <p>By accessing and using this website, you accept and agree to be bound by the terms and provision of this agreement.</p>
                
                <h2>Use License</h2>
                <p>Permission is granted to temporarily download one copy of the materials on Zero To Cloud's website for personal, non-commercial transitory viewing only.</p>
                
                <h2>Disclaimer</h2>
                <p>The materials on Zero To Cloud's website are provided on an 'as is' basis. Zero To Cloud makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.</p>
                
                <h2>Limitations</h2>
                <p>In no event shall Zero To Cloud or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on Zero To Cloud's website.</p>
                
                <h2>Accuracy of Materials</h2>
                <p>The materials appearing on Zero To Cloud's website could include technical, typographical, or photographic errors. Zero To Cloud does not warrant that any of the materials on its website are accurate, complete, or current.</p>
                
                <h2>Links</h2>
                <p>Zero To Cloud has not reviewed all of the sites linked to our website and is not responsible for the contents of any such linked site.</p>
                
                <h2>Modifications</h2>
                <p>Zero To Cloud may revise these terms of service for its website at any time without notice. By using this website, you are agreeing to be bound by the then current version of these terms of service.</p>
                
                <h2>Governing Law</h2>
                <p>These terms and conditions are governed by and construed in accordance with the laws and you irrevocably submit to the exclusive jurisdiction of the courts in that state or location.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

export default TermsAndConditionsPage;